import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { ContactUsRoutingModule } from './contact-us-routing.module';
import { ContactUsListComponent } from './components/contact-us-list/contact-us-list.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ContactUsListComponent
  ],
  imports: [
    CommonModule,
    ContactUsRoutingModule,
    MatPaginatorModule,
    MatDialogModule,
    SearchComponent
  ]
})
export class ContactUsModule { }


